import { cn } from '@/package';

export type SideBarState = 'active' | 'disabled' | 'default';

const twStateStyle = (state: SideBarState) =>
  cn({
    '!cursor-not-allowed !text-gray-500': state === 'disabled',
    'bg-blue-300 font-bold !text-skyBlue-200': state === 'active',
    'font-normal !text-gray-200': state === 'default',
  });

const twStyle = {
  SideBar: cn(
    'max-w-sidebar min-w-sidebar',
    'w-sidebar',
    'flex flex-col justify-between',
    'h-screen pb-8',
    'bg-primary-500',
    'shadow-sm',
    'overflow-auto',
  ),

  UpperWrapper: cn('flex flex-col'),

  TenantNameWrapper: cn('flex items-center justify-center px-2 py-[9px]'),
  TenantName: cn(
    'flex w-full items-center justify-center',
    'rounded-md bg-primary-400 p-2 text-body-lg font-bold text-gray-300',
  ),

  Category(state: SideBarState) {
    return cn(
      'flex cursor-pointer items-center gap-2 overflow-hidden rounded-md p-2 text-body-lg transition-colors hover:bg-primary-400',
      twStateStyle(state),
    );
  },
  CategoryIcon: cn('size-4 fill-current'),

  ItemSpan: cn('translate-y-[1px]'),
};

export default twStyle;
